// Canonical size order helper used across storefront + admin.
// Any size that isn't in the canonical list falls to the end, alphabetically.

const CANONICAL_ORDER = [
  'XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '2XL', '3XL', '4XL', '5XL',
  'FREE', 'ONESIZE', 'ONE SIZE',
];

const normalize = (s) => String(s || '').trim().toUpperCase().replace(/\s+/g, ' ');

export const sizeRank = (s) => {
  const n = normalize(s);
  const idx = CANONICAL_ORDER.indexOf(n);
  if (idx !== -1) return idx;
  // Handle 'UK 8', 'EU 42', '32', '9.5' — pull the trailing number for ascending numeric sort
  const numMatch = n.match(/(\d+(?:\.\d+)?)\s*$/);
  if (numMatch) {
    const num = parseFloat(numMatch[1]);
    // Bucket by prefix so 'UK 8' and 'EU 42' don't intermix: uses first non-digit chars as bucket
    const prefix = n.replace(/\d+(?:\.\d+)?\s*$/, '').trim();
    // Bucket base: pure numeric = 1000, UK = 2000, EU = 3000, other = 4000
    let base = 4000;
    if (!prefix) base = 1000;
    else if (prefix === 'UK') base = 2000;
    else if (prefix === 'EU') base = 3000;
    return base + num;
  }
  return 9999;
};

export const sortSizes = (arr) => {
  if (!Array.isArray(arr)) return [];
  return [...arr].sort((a, b) => {
    const ra = sizeRank(a);
    const rb = sizeRank(b);
    if (ra !== rb) return ra - rb;
    return String(a).localeCompare(String(b));
  });
};
